import React from "react";
import classnames from "classnames";
import { NavLink } from "react-router-dom";

// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container
} from "reactstrap";

import logo from "assets/img/logo-negative.png";
import logoGrou from "assets/img/self-guru-grou-novo.png";
import enviroment from "../../services/enviroment";
class AuthNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      color: "navbar-transparent",
      logo: logo,
    };
  }
  componentDidMount() {
    window.addEventListener("resize", this.updateColor);

    if (enviroment.isNewUserInterface()) {
      this.setState({logo: logoGrou});
    }
  }
  // this function opens and closes the collapse on small devices
  // it also adds navbar-transparent class to the navbar when closed
  // ad bg-white when opened
  toggleCollapse = () => {
    let newState = {
      collapseOpen: !this.state.collapseOpen
    };
    if (!this.state.collapseOpen) {
      newState["color"] = "bg-white";
    } else {
      newState["color"] = "navbar-transparent";
    }
    this.setState(newState);
  };
  render() {
    return (
      <Navbar
        className={classnames("navbar-absolute fixed-top", this.state.color)}
        expand="lg"
      >
        <Container>
          <div className="navbar-wrapper">
            <NavbarBrand href="https://www.selfguru.com.br/">
              <img src={this.state.logo} alt="selfguru-logo" />
            </NavbarBrand>
          </div>
          <button
            aria-controls="navigation-index"
            aria-expanded={false}
            aria-label="Toggle navigation"
            className="navbar-toggler"
            data-toggle="collapse"
            type="button"
            onClick={this.toggleCollapse}
          >
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </button>
          <Collapse
            isOpen={this.state.collapseOpen}
            className="justify-content-end"
            navbar
          >
            <Nav navbar>
              <NavItem>
                <NavLink to={"/auth/login" + window.location.search} className="nav-link">
                  <i className="nc-icon nc-tap-01" />
                  {window.gettext('Login')}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/auth/forgot-password" className="nav-link">
                  <i className="nc-icon nc-send" />
                  {window.gettext('Esqueci minha senha')}
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

export default AuthNavbar;
